import { type Organization } from 'shared/types'

import { httpClientBanking } from '~/domains/banking/shared/infra/http-client-banking'

export async function createOrganization(document: string, documentType = 'cnpj') {
  return httpClientBanking<Organization>({
    url: '/organizations',
    method: 'POST',
    data: { document, documentType }
  })
}
